var render = function render(){var _vm=this,_c=_vm._self._c;return _c('add-task-modal',{attrs:{"project-id":_vm.task.project_id,"task":_vm.task},on:{"close":function($event){return _vm.$emit('close')},"refresh":function($event){return _vm.$emit('refresh')},"deleted":function($event){return _vm.$emit('deleted', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }